export default "__VITE_ASSET__aIEWuPlO__"